import React, { useState } from 'react';
import { Button, Input, HeroTitle, Fieldset } from '@cof/gravity-react';

import { customerForm } from '../../strings';

import './CustomerForm.scss';

const numberRegex = /^[0-9]*$/;
const applicationIdRegex = /^[0-9]{14,17}$/;

const maskInput = (input, setFunction, maxLength, setCheckedFunction, setValidFunction) => {
    if (numberRegex.test(input) && (input.length <= maxLength)) {
        setFunction(input);
        if (input.length === maxLength || applicationIdRegex.test(input)) {
            setValidFunction(true);
            setCheckedFunction(true);
        }
    }
}

const CustomerForm = ({ pageData, activeLanguage, advancePage, showFaqDialog }) => {
    const [srn, setSrn] = useState('')
    const [srnChecked, setSrnChecked] = useState(false)
    const [srnValid, setSrnValid] = useState(false)

    const [social, setSocial] = useState('')
    const [socialChecked, setSocialChecked] = useState(false)
    const [socialValid, setSocialValid] = useState(false)

    const [zipCode, setZipCode] = useState('')
    const [zipCodeChecked, setZipCodeChecked] = useState(false)
    const [zipCodeValid, setZipCodeValid] = useState(false)

    const [applicationEntryPoint, setApplicationEntryPoint] = useState(pageData.applicationEntryPoint || '');

    const srnError = srnChecked && !srnValid;
    const zipError = zipCodeChecked && !zipCodeValid;
    const socialError = socialChecked && !socialValid;

    const formHasEmpty = srn === '' || social === '' || zipCode === '';
    const buttonDisabled = srnError || (srn.length < 14 || srn.length > 17) || zipError || zipCode.length !== 5 || socialError || social.length !== 4 || formHasEmpty;

    if ((document.location.pathname === '/funding' || (document.location.pathname === '/deposit')) && document.location.search.startsWith('?srn=')) {
        const searchParams = new URLSearchParams(document.location.search);
        const prefillSRN = searchParams.get('srn');
        maskInput(prefillSRN, setSrn, 17, setSrnChecked, setSrnValid);
        window.history.replaceState(null, null, '/');
        setApplicationEntryPoint('fromNewEmail');
    }

    return (
        <div className="customer-form">
            <HeroTitle>{customerForm[activeLanguage].AuthenticationFormTitle}</HeroTitle>
            <Fieldset legend={customerForm[activeLanguage].Subtitle}>
                <Input
                    label={customerForm[activeLanguage].CustomerNumber}
                    helper={customerForm[activeLanguage].Received}
                    value={srn}
                    id="customer-form-srn"
                    error={srnError && customerForm[activeLanguage].CustomerNumberBlank}
                    onChange={e => maskInput(e.target.value, setSrn, 17, setSrnChecked, setSrnValid)}
                    onBlur={e => { setSrnValid(srn.length >= 14 && srn.length <= 17); setSrnChecked(true); }}
                />
                <Input
                    label={customerForm[activeLanguage].Zip}
                    helper=""
                    value={zipCode}
                    id="customer-form-zip"
                    error={zipError && customerForm[activeLanguage].ZipCodeError}
                    onChange={e => maskInput(e.target.value, setZipCode, 5, setZipCodeChecked, setZipCodeValid)}
                    onBlur={e => { setZipCodeValid(zipCode.length === 5); setZipCodeChecked(true); }}
                />
                <Input
                    label={customerForm[activeLanguage].SSN}
                    helper=""
                    value={social}
                    id="customer-form-social"
                    error={socialError && customerForm[activeLanguage].SSNInvalid}
                    onChange={e => maskInput(e.target.value, setSocial, 4, setSocialChecked, setSocialValid)}
                    onBlur={e => { setSocialValid(social.length === 4); setSocialChecked(true); }}
                    onEnter={e => { social.length === 4 && !buttonDisabled && advancePage({ srn, social, zipCode, applicationEntryPoint }) }}
                />
                <div className="button-group">
                    <Button
                        constantWidth={false}
                        type="text"
                        onClick={showFaqDialog}
                    >
                        {customerForm[activeLanguage].FAQ}
                    </Button>
                    <Button
                        constantWidth={false}
                        type="progressive"
                        disabled={buttonDisabled}
                        onClick={e => { advancePage({ srn, social, zipCode, applicationEntryPoint }) }}
                    >
                        {customerForm[activeLanguage].MakeDeposit}
                    </Button>
                </div>
            </Fieldset>
        </div>
    )
}

export default CustomerForm;
